import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectReportsDashboardDomain = (state) =>
  state.get("reportsDashboard", initialState)

export const makeSelectIsLoadingDashboardData = () =>
  createSelector(selectReportsDashboardDomain, (state) =>
    state.get("isLoadingDashboardData")
  )

export const makeSelectDashboardData = () =>
  createSelector(selectReportsDashboardDomain, (state) =>
    state.get("dashboardData")
  )

export const makeSelectAmbassadorDivisions = () =>
  createSelector(selectReportsDashboardDomain, (state) =>
    state.get("ambassadorDivisions")
  )

export const makeSelectSelectedDivision = () =>
  createSelector(selectReportsDashboardDomain, (state) =>
    state.get("selectedDivision")
  )

const makeSelectReportsDashboard = () =>
  createSelector(selectReportsDashboardDomain, (substate) => substate.toJS())

export default makeSelectReportsDashboard
export { selectReportsDashboardDomain }
